module.exports = __webpack_public_path__ + "img/down_sort.01b75015.svg";